import semver from "semver";
import { PRISMIC_CLI_NPM_PACKAGE_NAME } from "../../constants/PRISMIC_CLI_NPM_PACKAGE_NAME.js";
import { fetchNPMPackageVersions } from "../../lib/fetchNPMPackageVersions.js";
import { BaseManager } from "../BaseManager.js";
class VersionsManager extends BaseManager {
  /**
   * Fetches the latest stable version of the Prismic CLI from npm.
   *
   * @returns The latest stable version string.
   */
  async getLatestCLIVersion() {
    const versions = await fetchNPMPackageVersions({
      packageName: PRISMIC_CLI_NPM_PACKAGE_NAME
    });
    const stableVersions = versions.filter((version) => {
      return semver.prerelease(version) === null;
    });
    if (stableVersions.length === 0) {
      throw new Error("No stable versions found for the package on the npm registry.");
    }
    const sortedVersions = semver.rsort(stableVersions);
    return sortedVersions[0];
  }
  /**
   * Checks if the current CLI version is the latest available version.
   *
   * @param args - Arguments object containing the current version.
   *
   * @returns `true` if the current version is the latest, `false` otherwise.
   */
  async checkIsCLIVersionLatest(args) {
    const latestVersion = await this.getLatestCLIVersion();
    return semver.eq(args.currentVersion, latestVersion);
  }
}
export {
  VersionsManager
};
//# sourceMappingURL=VersionsManager.js.map
